"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentState = void 0;
var AssessmentState;
(function (AssessmentState) {
    AssessmentState["UNASSIGNED"] = "UNASSIGNED";
    AssessmentState["ASSIGNED"] = "ASSIGNED";
    AssessmentState["IN_PROGRESS"] = "IN_PROGRESS";
    AssessmentState["ASSESSOR_COMPLETE"] = "ASSESSOR_COMPLETE";
    AssessmentState["IN_REVIEW"] = "IN_REVIEW";
    AssessmentState["STORM_CENTER_VERIFIED"] = "STORM_CENTER_VERIFIED";
    AssessmentState["CANCELLED"] = "CANCELLED";
})(AssessmentState = exports.AssessmentState || (exports.AssessmentState = {}));
//# sourceMappingURL=stormDocumentState.js.map